import { SyncDiff } from '@constants/profiles';

const FIELD_LABELS = {
    [SyncDiff.LocationName]: t => t('SettingsCompanies.locationName'),
    [SyncDiff.Status]: t => t('common.status'),
    [SyncDiff.PhoneNumber]: t => t('SettingsCompanies.primaryPhone'),
    [SyncDiff.AdditionalPhones]: t => t('SettingsCompanies.additionalPhones'),
    [SyncDiff.Website]: t => t('SettingsCompanies.website'),
    [SyncDiff.Address]: t => t('SettingsCompanies.address'),
    [SyncDiff.BusinessHours]: t => t('SettingsCompanies.businessHours'),
    [SyncDiff.SpecialHours]: t => t('SettingsCompanies.specialHours'),
    [SyncDiff.Description]: t => t('common.description'),
    [SyncDiff.OpeningDate]: t => t('SettingsCompanies.openingDate'),
    [SyncDiff.PrimaryCategory]: t => t('Listings.primaryCategory'),
    [SyncDiff.SecondaryCategories]: t => t('Listings.secondaryCategory_other'),
    [SyncDiff.Logo]: t => t('common.logo'),
    [SyncDiff.CoverPhoto]: t => t('SettingsCompanies.coverPhoto'),
    [SyncDiff.Facebook]: () => 'Facebook',
    [SyncDiff.Instagram]: () => 'Instagram',
    [SyncDiff.Youtube]: () => 'YouTube',
    [SyncDiff.X]: () => 'X',
    [SyncDiff.LinkedIn]: () => 'LinkedIn',
    [SyncDiff.Tiktok]: () => 'TikTok',
    [SyncDiff.Pinterest]: () => 'Pinterest',
    [SyncDiff.Chat]: t => t('common.chat'),
};

export const ignoredFieldOptions = ({ comparedFields = [], syncDiff = [], t }) =>
    comparedFields
        .filter(field => FIELD_LABELS[field])
        .map(field => {
            const label = FIELD_LABELS[field](t);
            return {
                value: field,
                label: syncDiff.includes(field) ? `${label} (${t('Listings.currentlyDifferent')})` : label,
            };
        });
